{
  "tabs": {
    "chat": "Chat",
    "reminders": "Erinnerungen",
    "calendar": "Kalender",
    "settings": "Einstellungen"
  },
  "common": {
    "cancel": "Abbrechen",
    "save": "Speichern",
    "confirm": "Bestätigen",
    "delete": "Löschen",
    "back": "Zurück",
    "close": "Schließen",
    "edit": "Bearbeiten",
    "search": "Suchen",
    "all": "Alle",
    "loading": "Lädt...",
    "error": "Etwas ist schiefgelaufen",
    "notFound": "Nicht gefunden",
    "tryAgain": "Bitte erneut versuchen",
    "retry": "Erneut",
    "undo": "Rückgängig",
    "pullToRefresh": "Zum Aktualisieren ziehen",
    "justNow": "gerade eben"
  },
  "auth": {
    "welcome": "Willkommen bei FishMemory",
    "tagline": "Dein WhatsApp Erinnerungsassistent, jetzt in deiner Tasche.",
    "subtitle": "Dein WhatsApp Erinnerungsassistent, jetzt in deiner Tasche.",
    "phoneLabel": "Deine WhatsApp-Nummer",
    "phoneHint": "Wir senden einen Bestätigungscode via WhatsApp",
    "invalidPhone": "Bitte gib eine gültige Telefonnummer ein",
    "continue": "Weiter",
    "enterPhone": "Gib deine WhatsApp-Nummer ein",
    "phonePlaceholder": "Telefonnummer",
    "sendCode": "Code senden",
    "verifyTitle": "Nummer verifizieren",
    "otpSentTo": "Ein 6-stelliger Code wurde an {{phone}} via WhatsApp gesendet",
    "enterFullCode": "Bitte alle 6 Ziffern eingeben",
    "invalidOtp": "Ungültiger Code. Bitte erneut versuchen.",
    "otpFailed": "Code konnte nicht gesendet werden. Erneut versuchen.",
    "otpResent": "Code erneut gesendet",
    "resendIn": "Erneut senden in {{seconds}}s",
    "resendCode": "Code erneut senden",
    "enterOtp": "Gib den an WhatsApp gesendeten Code ein",
    "verify": "Verifizieren",
    "resend": "Code erneut senden",
    "wrongNumber": "Falsche Nummer?",
    "backToPhone": "Zurück zur Nummer",
    "editPhone": "Nummer bearbeiten",
    "error": "Fehler",
    "setupTitle": "Lass uns starten",
    "setupSubtitle": "Du kannst das später jederzeit in den Einstellungen ändern",
    "namePlaceholder": "Dein Name",
    "letsGo": "Setup abschließen",
    "skipForNow": "Jetzt überspringen"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Nachricht eingeben...",
    "inputPlaceholder": "Nachricht eingeben...",
    "typing": "FishMemory tippt...",
    "online": "Online",
    "connecting": "Verbindung wird hergestellt...",
    "reconnecting": "Verbindung wird wiederhergestellt...",
    "offline": "Offline",
    "empty": "Starte eine Unterhaltung",
    "emptyHint": "Erstelle Erinnerungen, prüfe deinen Kalender oder frage um Hilfe.",
    "emptyAction": "Beispiel-Erinnerung senden",
    "actions": "Chat-Aktionen",
    "keep": "Nachrichten behalten",
    "clearTitle": "Chat löschen",
    "clearConfirm": "Alle Nachrichten auf diesem Gerät löschen? Dies kann nicht rückgängig gemacht werden.",
    "clear": "Chat löschen",
    "optionSelected": "Ausgewählt: {{label}}",
    "sendingSelection": "Sende...",
    "connectionLost": "Verbindung wird wiederhergestellt..."
  },
  "reminders": {
    "title": "Meine Erinnerungen",
    "active": "Aktiv",
    "today": "Heute",
    "thisWeek": "Diese Woche",
    "history": "Verlauf",
    "items": "Elemente",
    "emptyTitle": "Noch keine Erinnerungen",
    "emptySubtitle": "Erstelle eine im Chat, sie wird hier angezeigt.",
    "emptyAction": "Chat öffnen",
    "filterActive": "Aktiv",
    "filterToday": "Heute",
    "filterWeek": "Diese Woche",
    "filterHistory": "Verlauf",
    "emptyState": "Noch keine Erinnerungen. Starte den Chat!",
    "swipeDone": "Erledigt",
    "swipeSnooze": "Schlummern",
    "swipeDelete": "Löschen",
    "search": "Erinnerungen suchen...",
    "upcoming": "Bevorstehend",
    "completed": "Erledigt",
    "overdue": "Überfällig",
    "tomorrow": "Morgen",
    "synced": "Synchronisiert {{value}}",
    "swipeHint": "Wische eine Erinnerung für mehr Aktionen",
    "noResults": "Keine Erinnerungen gefunden",
    "noResultsHint": "Versuche ein anderes Stichwort oder lösche die Suche",
    "deleteAllFailed": "Löschen aller Erinnerungen fehlgeschlagen"
  },
  "calendar": {
    "title": "Kalender",
    "today": "Heute",
    "tomorrow": "Morgen",
    "completed": "erledigt",
    "noEvents": "Keine Termine",
    "noEventsSubtitle": "Wähle ein Datum, um Erinnerungen und Termine zu sehen.",
    "googleEvent": "Google Kalender",
    "legendActive": "Aktiv",
    "legendRecurring": "Wiederkehrend",
    "legendDone": "Erledigt",
    "legendGoogle": "Google",
    "previousMonth": "Letzter Monat",
    "nextMonth": "Nächster Monat",
    "previousYear": "Letztes Jahr",
    "nextYear": "Nächstes Jahr",
    "goToToday": "Zu heute",
    "all": "Alle",
    "active": "Aktiv",
    "done": "Erledigt",
    "paused": "Pausiert"
  },
  "settings": {
    "title": "Einstellungen",
    "profile": "Profil",
    "name": "Anzeigename",
    "enterName": "Name eingeben",
    "language": "Sprache",
    "uiLanguage": "App-Sprache",
    "uiLanguageHelp": "Ändert die App-Oberfläche, Kalenderbeschriftungen und Layoutrichtung nur auf diesem Gerät.",
    "serverLanguage": "Chat-Sprache",
    "serverLanguageHelp": "Ändert die Sprache der Serverantworten und Erinnerungsnachrichten für dein Konto.",
    "timezone": "Zeitzone",
    "currentTimezone": "Aktuelle Zeitzone",
    "timezoneHelp": "Alle Erinnerungszeiten werden in dieser Zeitzone angezeigt.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Zeitzone speichern",
    "timezoneSaved": "Zeitzone aktualisiert",
    "detect": "Erkennen",
    "detectFailed": "Zeitzone konnte nicht erkannt werden",
    "autoDetect": "Automatisch per GPS erkennen",
    "notifications": "Benachrichtigungen",
    "notificationsHelp": "Folge-Erinnerungen steuern wiederholte Alarme nach einer Erinnerung. Geräte-Benachrichtigungen werden in den Telefoneinstellungen verwaltet.",
    "pushEnabled": "Push-Benachrichtigungen",
    "autoDoneOnFire": "Automatisch als erledigt markieren",
    "autoDoneOnFireDesc": "Wenn aus, bleiben Erinnerungen aktiv, bis du sie als erledigt markierst.",
    "googleCalendar": "Google Kalender",
    "google": "Google Kalender",
    "googleConnected": "Verbunden",
    "googleDisconnected": "Nicht verbunden",
    "googleConnectedHelp": "Neue Erinnerungen können automatisch mit deinem Kalender synchronisiert werden.",
    "googleDisconnectedHelp": "Verbinde Google Kalender, um Erinnerungen und Termine abzugleichen.",
    "googleConnectFailed": "Verbindung zu Google Kalender fehlgeschlagen",
    "connected": "Verbunden",
    "disconnected": "Nicht verbunden",
    "connect": "Verbinden",
    "disconnect": "Trennen",
    "autoSync": "Neue Erinnerungen automatisch synchronisieren",
    "autosync": "Neue Erinnerungen automatisch synchronisieren",
    "subscription": "Abonnement",
    "trialUsed": "Testphase: {{used}}/{{total}} genutzt",
    "trialStatus": "Testphase verfügbar",
    "activeStatus": "Aktives Abonnement",
    "expiredStatus": "Abonnement abgelaufen",
    "unsubscribedStatus": "Nicht abonniert",
    "about": "Info",
    "version": "Version",
    "logout": "Abmelden",
    "logoutTitle": "Abmelden",
    "logoutConfirm": "Möchtest du dich wirklich abmelden?",
    "noName": "Kein Name gesetzt",
    "serverConnection": "Serververbindung",
    "serverUrl": "Server-URL",
    "serverEdit": "Bearbeiten",
    "saveReconnect": "Speichern und neu verbinden",
    "resetDefault": "Standard zurücksetzen",
    "invalidServerUrlTitle": "Ungültige Server-URL",
    "invalidServerUrlMessage": "Bitte gib eine gültige http- oder https-Server-URL ein, z.B. https://example.com",
    "uiLanguageChangeFailed": "App-Sprache konnte nicht geändert werden. Bitte erneut versuchen.",
    "serverLanguageChangeFailed": "Chat-Sprache konnte nicht geändert werden. Bitte erneut versuchen.",
    "timezoneChangeFailed": "Zeitzone konnte nicht geändert werden. Bitte erneut versuchen.",
    "autoSyncChangeFailed": "Auto-Sync konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    "nameChangeFailed": "Anzeigename konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Erinnerungsdetails",
    "editTime": "Zeit bearbeiten",
    "rename": "Umbenennen",
    "snooze": "Schlummern",
    "snooze15": "15 Minuten schlummern",
    "pause": "Pause",
    "pauseReminder": "Erinnerung pausieren",
    "resume": "Fortsetzen",
    "resumeReminder": "Erinnerung fortsetzen",
    "skip": "Nächstes überspringen",
    "skipOccurrence": "Dieses Vorkommen überspringen",
    "syncGoogle": "Mit Google synchronisieren",
    "delete": "Löschen",
    "deleteTitle": "Erinnerung löschen",
    "deleteConfirm": "Diese Erinnerung wird dauerhaft gelöscht.",
    "deleteRecurringTitle": "Wiederkehrende Erinnerung löschen",
    "deleteRecurringMessage": "Möchtest du dieses Vorkommen überspringen oder die gesamte Serie löschen?",
    "deleteThisOccurrence": "Dieses Vorkommen überspringen",
    "deleteEntireSeries": "Gesamte Serie löschen",
    "done": "Erledigt",
    "markDone": "Als erledigt markieren",
    "undo": "Wiederherstellen",
    "undoPrompt": "Noch aktiv? Jetzt wiederherstellen.",
    "recurring": "Wiederkehrend",
    "nextRun": "Nächste Ausführung",
    "oneTime": "Einmalig",
    "pending": "Ausstehend",
    "sent": "Gesendet",
    "paused": "Pausiert",
    "active": "Aktiv",
    "snoozed": "Geschlummert",
    "localTime": "In deiner Ortszeit angezeigt",
    "recurrence": "Wiederholung",
    "created": "Erstellt",
    "tags": "Tags",
    "fireCount": "Auslösungen",
    "actions": "Aktionen",
    "none": "Keine",
    "snoozeFailed": "Schlummern fehlgeschlagen",
    "pauseFailed": "Pause fehlgeschlagen",
    "resumeFailed": "Fortsetzen fehlgeschlagen",
    "skipFailed": "Überspringen fehlgeschlagen",
    "doneFailed": "Als erledigt markieren fehlgeschlagen",
    "undoFailed": "Wiederherstellung fehlgeschlagen",
    "deleteFailed": "Löschen fehlgeschlagen",
    "rescheduleTitle": "Neu planen?",
    "rescheduleMsg": "Diese Erinnerung ist überfällig. Möchtest du sie neu planen?",
    "reschedule15": "In 15 Minuten",
    "reschedule60": "In 1 Stunde",
    "keepOverdue": "So behalten"
  },
  "onboarding": {
    "slide1Title": "Willkommen bei FishMemory",
    "slide1Sub": "Dein persönlicher Erinnerungsassistent – powered by WhatsApp und für deine Tasche gemacht.",
    "slide2Title": "Einfach natürlich chatten",
    "slide2Sub": "Tippe Erinnerungen so, wie du denkst: „Erinnere mich morgen um 15 Uhr, Mama anzurufen“ – wir erledigen den Rest.",
    "slide3Title": "Nichts mehr verpassen",
    "slide3Sub": "Erhalte rechtzeitige Benachrichtigungen, organisiere mit Tags und behalte alles Wichtige im Blick.",
    "getStarted": "Loslegen",
    "next": "Weiter",
    "firstReminderTitle": "Erstelle deine erste Erinnerung!",
    "firstReminderHint": "Versuche etwas zu tippen wie:",
    "firstReminderExample": "Erinnere mich morgen um 9 Uhr ans Wassertrinken",
    "gotIt": "Verstanden!",
    "notifRationaleTitle": "Bleib pünktlich",
    "notifRationaleBody": "FishMemory benötigt Benachrichtigungen, um dich rechtzeitig zu erinnern. Du erhältst nur Alarme für deine Erinnerungen.",
    "notifRationaleAllow": "Benachrichtigungen aktivieren",
    "notifRationaleLater": "Vielleicht später",
    "swipeHint": "Nach rechts wischen für Schnellaktionen →",
    "calendarDragHint": "Ziehen zum Erweitern ↕"
  }
}
